import React, { useState, useEffect, useRef } from 'react';
import '../index.css';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import { useProperty } from '../context/PropertyContext.js';
import StarRating from './StarRating.js';
import { useComment } from '../context/commentContext.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useReply } from '../context/ReplyContext.js';
import ReplyIcon from '../assets/send.png';


const EditReply = ({ isOpen, onClose, reply: currentReply }) => {
  const serverUrl = 'https://osdevhub.com/homify_backend/api/properties';
    const [replyText, setReplyText] = useState("");
  

  const {updateReply, getRepliesForProperty, replyIsLoading} = useReply();

    const navigate = useNavigate();
        const {id: property_id} = useParams()
    const {user} = useAuth();
    const user_id = user.id

  const [formData, setFormData] = useState({
    reply : currentReply?.reply || '',
  });

  useEffect(() => {
    if (currentReply) {
        setFormData({
            reply : currentReply?.reply || '',
        })
    }
  }, [currentReply])
  

  const [error, setError] = useState(null);
  const modalRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault()
    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
        
        data.append(key, value);
    });



    try {

      await updateReply(currentReply.id, data)
      await getRepliesForProperty(property_id);

        toast.success('Reply updated successfully', {
          position: "top-right",
          autoClose: 2000
      });

        setTimeout(() => {
          onClose();
        }, 3000)
      
    } catch (err) {
      console.error("Update error:", err);
      setError("Failed to update property.");
      
              toast.error('Reply was not updated successfully', {
                position: "top-right",
                autoClose: 2000
            });
      
              setTimeout(() => {
                onClose();
              }, 3000)
            
    }
  };



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  function handleReplyTextChange(e) {
    let value = e.target.value;

    setFormData((prevData) => ({
        ...prevData,
        reply : value
    }))

    setReplyText(value);
    
}

  if (!isOpen) return null;

  if(!currentReply) return null

  return (
    <div className="modal-container">
      <ToastContainer />
      <div className="userdata-modal-content" ref={modalRef}>
        <div className="add-text-header">
          <h3>Edit Reply</h3>
          <span onClick={onClose} className="close">&times;</span>
        </div>
        <div id="user-data-content-container-location" className="margin-top">
             
            <form onSubmit={handleSubmit} className='reply-form'>
                    <input value={formData.reply} onChange={handleReplyTextChange} className='reply-input' type='text' />
                    <button className='reply-button-out' type='submit'>
                        {
                            replyIsLoading ? <p style={{color: '#000'}}>Loading...</p> :   <img src={ReplyIcon} alt='reply-button' className='reply-button' />
                        }
                        
                      
                        
                    </button>
                </form>

        </div>
      </div>
    </div>
  );
};

export default EditReply;
